import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { Form, Switch } from "antd";
import { useFormService, useI18n, useUpsell } from "../../../../../contexts";
import { FormServiceLayout } from "../..";
import { FormValueDifferFromTemplateTag } from "../../..";
import { getManagerDependingVariables } from "@devowl-wp/cookie-consent-web-client";
const FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven = (param)=>{
    let { name } = param;
    const { __, _i } = useI18n();
    const { isPro } = useUpsell();
    const { setCookiesViaManager, isGcm, template } = useFormService();
    const [ref, setRef] = useState();
    const { managerLabel, features } = getManagerDependingVariables(setCookiesViaManager, {
        isGcm,
        presetId: template == null ? void 0 : template.identifier
    });
    const executeCodeWhenNoTagManagerConsentIsGivenLabel = _i(__("Only run this script if the user has {{u}}not{{/u}} allowed to use %s", managerLabel), {
        u: /*#__PURE__*/ _jsx("u", {})
    });
    return isPro && features.executeCodeWhenNoTagManagerConsentIsGiven ? /*#__PURE__*/ _jsxs(Form.Item, {
        required: true,
        wrapperCol: {
            offset: FormServiceLayout.labelCol.span,
            span: FormServiceLayout.wrapperCol.span
        },
        children: [
            /*#__PURE__*/ _jsx(Form.Item, {
                name: name,
                valuePropName: "checked",
                noStyle: true,
                children: /*#__PURE__*/ _jsx(Switch, {})
            }),
            /*#__PURE__*/ _jsxs("span", {
                children: [
                    "\xa0\xa0",
                    executeCodeWhenNoTagManagerConsentIsGivenLabel
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                style: {
                    marginTop: 10
                },
                ref: setRef,
                children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                    form: "service",
                    valueName: name,
                    widthOfRef: ref,
                    renderDiff: (value)=>/*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(Switch, {
                                    disabled: true,
                                    checked: value
                                }),
                                /*#__PURE__*/ _jsxs("span", {
                                    children: [
                                        "\xa0\xa0",
                                        executeCodeWhenNoTagManagerConsentIsGivenLabel
                                    ]
                                })
                            ]
                        }),
                    noBr: true
                })
            })
        ]
    }) : null;
};
export { FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven };
